var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatingEdge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#0B4A62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10631_28309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 12C5.33203 12.8752 5.50448 13.7419 5.83953 14.5505C6.17457 15.3592 6.66566 16.0939 7.28475 16.7128C7.90384 17.3317 8.6388 17.8227 9.44768 18.1576C10.2566 18.4926 11.1235 18.665 11.999 18.665C12.8745 18.665 13.7415 18.4926 14.5504 18.1576C15.3592 17.8227 16.0942 17.3317 16.7133 16.7128C17.3324 16.0939 17.8235 15.3592 18.1585 14.5505C18.4936 13.7419 18.666 12.8752 18.666 12C18.666 11.1247 18.4936 10.258 18.1585 9.44938C17.8235 8.64074 17.3324 7.906 16.7133 7.28709C16.0942 6.66819 15.3592 6.17725 14.5504 5.8423C13.7415 5.50736 12.8745 5.33496 11.999 5.33496C11.1235 5.33496 10.2566 5.50736 9.44768 5.8423C8.6388 6.17725 7.90384 6.66819 7.28475 7.28709C6.66566 7.906 6.17457 8.64074 5.83953 9.44938C5.50448 10.258 5.33203 11.1247 5.33203 12Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 5.33496C12.8745 5.33496 13.7415 5.50736 14.5504 5.8423C15.3592 6.17725 16.0942 6.66819 16.7133 7.28709C17.3324 7.906 17.8235 8.64074 18.1585 9.44938C18.4936 10.258 18.666 11.1247 18.666 12C18.666 12.8752 18.4936 13.7419 18.1585 14.5505C17.8235 15.3592 17.3324 16.0939 16.7133 16.7128C16.0942 17.3317 15.3592 17.8227 14.5504 18.1576C13.7415 18.4926 12.8745 18.665 11.999 18.665C11.1235 18.665 10.2566 18.4926 9.44768 18.1576C8.6388 17.8227 7.90384 17.3317 7.28475 16.7128C6.66566 16.0939 6.17457 15.3592 5.83953 14.5505C5.50448 13.7419 5.33203 12.8752 5.33203 12C5.33203 11.1247 5.50448 10.258 5.83953 9.44938",
    stroke: "#17B2EB",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10631_28309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatingEdge);
export default __webpack_public_path__ + "static/media/updatingEdge.0e046fc26d7c3cf69ea237e019355a4d.svg";
export { ForwardRef as ReactComponent };